import "./ClockodoLogo.css";
import logo from "../../assets/clockodoImagepng.png";

interface Props {
  clockodoId: string;
}

function ClockodoLogo({ clockodoId }: Props) {
  return (
    <>
      <div className="logo-container">
        <a
          href={`https://my.clockodo.com/de/projectreports/report?id=${clockodoId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} alt="Clockodo Logo" className="clockodo-logo"></img>
        </a>
      </div>
    </>
  );
}

export default ClockodoLogo;
